import { gql, useQuery } from "@apollo/client";

const GetActiveIntentsForStudentQuery = gql`
  query getActiveIntentsForStudent($studentId: String!) {
    getActiveIntentsForStudent(studentId: $studentId) {
      id
      user1on1ClassroomPlanToBeRedeemedId
    }
  }
`;

type ActiveIntent = {
  id: string;
  user1on1ClassroomPlanToBeRedeemedId?: string | null;
};

type GetActiveIntentsForStudentResult = {
  getActiveIntentsForStudent: ActiveIntent[];
};

export function useGetActiveIntentsForStudent(studentId: string) {
  const { data, loading } = useQuery<GetActiveIntentsForStudentResult>(
    GetActiveIntentsForStudentQuery,
    {
      variables: { studentId },
      skip: !studentId,
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    activeIntents: data?.getActiveIntentsForStudent ?? [],
    loading,
  };
}
